HomePageApp.Models.Stats = Backbone.Model.extend({
    
    urlRoot: '/api/home/current',
    
    defaults: {
        date: null,
        value: null
    }

});